import Klaro from '../vendor/Klaro';
import BootstrapCarousel from '../vendor/BootstrapCarousel';
import Navbar from '../utils/Navbar';

// Scripts that will be used globally on the front.

// Common global scripts
require('./common');

// Vendor
Klaro.init();
BootstrapCarousel.init();
Navbar.init();
//GTM.init();

if (typeof window.dataLayer !== 'undefined') {
    document.addEventListener('quote:sent', function () {
        window.dataLayer.push({'event': 'quoteSent'});
    });
}
